import { FC } from "react";
import { RaffleUserCell } from "./RaffleUserCell";

import styles from "./RaffleTable.module.css";

interface Props {
  fids: number[];
  // Сквозная нумерация между страницами.
  offset?: number;
}

// Публичные списки (победители, участники) — только fid, без призов и дат.
export const UserIdsTable: FC<Props> = ({ fids, offset = 0 }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        <th>#</th>
        <th>User ID</th>
      </tr>
    </thead>
    <tbody>
      {fids.map((fid, index) => (
        // Один fid может занять несколько призовых мест.
        <tr key={`${fid}-${index}`}>
          <td className={styles.index}>{offset + index + 1}</td>
          <td>
            <RaffleUserCell fid={fid} />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
